// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dollar-handle {\n  min-width: 20%;\n  max-width: 20%;\n}\n", ""]);
// Exports
module.exports = exports;
